module.exports = "//static.hsappstatic.net/LoginUI/static-1.14890/img/hubspotMobileApp2FA.png"